import * as React from 'react'
import { ImagePlus, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export interface UploadedImage {
  filename: string
  url: string
}

export function ImageUpload({
  image,
  label,
  pending = false,
  onChoose,
  onRemove,
}: {
  image: UploadedImage | null
  label: string
  pending?: boolean
  onChoose: (file: File) => void
  onRemove: () => void
}) {
  const inputRef = React.useRef<HTMLInputElement>(null)
  const chooseLabel = image ? 'Replace' : 'Upload image'

  return (
    <div className="flex items-center gap-2">
      {image ? (
        <img
          src={image.url}
          alt={`${label} preview`}
          className="h-16 w-16 shrink-0 rounded object-cover"
        />
      ) : (
        <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded border border-dashed border-input bg-muted/30">
          <ImagePlus className="h-5 w-5 text-muted-foreground" aria-hidden="true" />
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        aria-label={label}
        className="sr-only"
        onChange={(event) => {
          const file = event.target.files?.[0]
          if (file) onChoose(file)
          event.target.value = ''
        }}
      />
      <Button
        type="button"
        variant="outline"
        className="h-9 px-3"
        disabled={pending}
        onClick={() => inputRef.current?.click()}
      >
        {pending ? 'Uploading…' : chooseLabel}
      </Button>
      {image && (
        <Button
          type="button"
          variant="outline"
          className="h-9 w-9 border-transparent p-0 text-muted-foreground"
          aria-label="Remove image"
          disabled={pending}
          onClick={onRemove}
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  )
}
